
export default {
  name: "SnackbarComponent",
  props: {
    message: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    timeout: {
      type: Number,
      default: 3000
    },
    actionText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: true
    };
  },
  methods: {
    handleSnackbarClose() {
      this.visible = false;
      this.$emit('close');
    },
    handleActionClick() {
      this.$emit('action');
    }
  }
}
